/** Caminho da trilha de um produto, com o código escapado. */
export function caminhoDaTrilha(produto: string): string {
  return `/movimentacoes/produto?codigo=${encodeURIComponent(produto)}`;
}

/** Caminho do detalhe de uma movimentação em duas etapas. */
export function caminhoDaAbertura(id: string): string {
  return `/movimentacoes/aberturas/${encodeURIComponent(id)}`;
}
